export const messages = {
  en: {
    receiptPrintSetting: {
      title: 'Receipt Print Setting',
      tip: 'Configure the receipt header, footer note and QR code for small-ticket printing. The settings take effect on the receipt print page.',
      receiptName: 'Receipt Header',
      receiptNamePlaceholder: 'e.g. XX Property Management Co., Ltd.',
      receiptNameTip: 'Printed at the top of the receipt, defaults to community name if empty',
      content: 'Footer Note',
      contentPlaceholder: 'Optional, e.g. thank-you message or payment instructions',
      qrImg: 'QR Code',
      qrImgTip: 'Printed at the bottom of the receipt, e.g. official account QR code',
      save: 'Save',
      reset: 'Reset',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Save failed',
      fetchError: 'Failed to load settings',
      nameMaxLength: 'Header cannot exceed 128 characters'
    }
  },
  zh: {
    receiptPrintSetting: {
      title: '小票收据设置',
      tip: '配置小票打印收据的抬头、底部说明与二维码，保存后即时生效于收据打印。',
      receiptName: '收据抬头',
      receiptNamePlaceholder: '例如：XX物业服务有限公司',
      receiptNameTip: '打印在收据顶部，不填则默认显示小区名称',
      content: '底部说明',
      contentPlaceholder: '选填，例如：感谢您的缴费，或缴费须知等',
      qrImg: '二维码图片',
      qrImgTip: '打印在收据底部，例如公众号二维码',
      save: '保存',
      reset: '重置',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      fetchError: '加载设置失败',
      nameMaxLength: '收据抬头不能超过128个字符'
    }
  }
}
